export default "__VITE_ASSET__a1f5c9bc__"